module.exports = __webpack_public_path__ + "static/media/ip_telephone.51c1470c.jpg";